import React, { Component } from 'react';
import { Tabs } from 'antd';
import moment from 'moment';

import VirtualTable from './VirtualTable';
import './VirtualTable/style.css';

const months = [
    { key: '1', name: 'Я', title: 'Январь' },
    { key: '2', name: 'Ф', title: 'Февраль' },
    { key: '3', name: 'М', title: 'Март' },
    { key: '4', name: 'А', title: 'Апрель' },
    { key: '5', name: 'М', title: 'Май' },
    { key: '6', name: 'И', title: 'Июнь' },
    { key: '7', name: 'И', title: 'Июль' },
    { key: '8', name: 'А', title: 'Август' },
    { key: '9', name: 'С', title: 'Сентябрь' },
    { key: '10', name: 'О', title: 'Октябрь' },
    { key: '11', name: 'Н', title: 'Ноябрь' },
    { key: '12', name: 'Д', title: 'Декабрь' },
];

class TabsMonths extends Component {
    renderTabs() {
        return months.map(r => {
            return <Tabs.TabPane
                key={r.key}
                tab={<div title={r.title}>{r.name}</div>} 
            >
            </Tabs.TabPane>
        })
    }

    render() { 
        return <div className={'tabs-months'} style={this.props.style}>
            <Tabs 
                tabPosition={'left'}
                defaultActiveKey={this.props.month}
                onChange={this.props.onChange} 
            >
                {this.renderTabs()}
            </Tabs>
        </div>
    }
};

export default TabsMonths;


// WEBPACK FOOTER //
// ./src/components/TabsMonths.jsx